<template>
  <!-- On expose la méthode trigger au slot -->
  <slot :trigger="trigger"></slot>
</template>

<script>
import { defineComponent } from 'vue'
import Service from '../../dataService.js'
import sendBugAlert from '@/shared/errors/sendBugAlert.js'

export default defineComponent({
  name: 'ActionTrigger',
  emits: ['launching', 'success', 'failed'],
  props: {
    dataKey: { type: String, required: true },
    method: { type: String, default: 'post' },
    ignoreLoading: { type: Boolean, default: false },
  },
  methods: {
    async trigger(params = {}) {
      params.ignoreLoading = this.ignoreLoading
      this.$emit('launching', { params })

      let result
      try {
        result = await Service.triggerAction(this.dataKey, params, this.method)
        if (!result) throw new Error('No result from action')
        await new Promise(r => setTimeout(r, 450))
        if (result.statusCode !== 200) {
          this.$emit('failed', { params, error: result.error, result })
          sendBugAlert(result.error, { params, result }, false)
        } else this.$emit('success', { params, result, error: null })
        return result
      } catch (error) {
        sendBugAlert(error, { params, result }, false)
        await new Promise(r => setTimeout(r, 450))
        this.$emit('failed', { params, error, result: null })
      }
    },
  },
})
</script>
